import styled, { keyframes } from "styled-components";
import { Col } from "reactstrap";

export const Block = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 0px 5px 0px rgba(65, 65, 65, 0.2);
  margin-bottom: 200px;
`;

export const SmallBlock = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 5px;
  box-shadow: 0 0px 5px 0px rgba(65, 65, 65, 0.2);
  margin-bottom: 5px;
  margin-right: 20px;
`;

export const HeaderDetails = styled.div`
  background: #f2f6fe;
  padding: ${({ padding }) => padding || "40px 20px"};
`;

export const OutlineBtn = styled.div`
  height: 38px;
  line-height: 38px;
  font-weight: 500;
  font-size: 12px;
  border: 1px solid ${({ outline }) => outline || "#9699b4"};
  border-radius: 6px;
  color: #2b2a74;
  padding: 0px 22px;
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
  transition: 0.3s ease all;

  :hover {
    opacity: 0.9;
  }
`;

export const SectionTitle = styled.div`
  font-size: 12px;
  color: var(--grey-color);
  font-weight: 600;
  margin-bottom: 10px;
  display: inline-block;
`;

export const ProgressState = styled.div`
  ${({ progress }) => {
    const states = {
      completed: (opacity) => `rgba(40, 181, 54, ${opacity})`,
      inProgress: (opacity) => `rgba(250, 165, 2, ${opacity})`,
      started: (opacity) => `rgba(250, 165, 2, ${opacity})`,
      notStarted: (opacity) => `rgba(219, 53, 69, ${opacity})`,
      unavailable: (opacity) => `rgba(190, 190, 190, ${opacity})`,
      disabled: (opacity) => `rgba(219, 53, 69, ${opacity})`,
      available: (opacity) => `rgba(53, 219, 2, ${opacity})`,
    };

    return `
      border: 1px solid ${states[progress](1)};
      background: ${states[progress](0.3)};
      color: ${states[progress](1)};
    `;
  }}
  height: 30px;
  line-height: 30px;
  border-radius: 100px;
  margin-top: 20px;
  max-width: 180px;
  width: 100%;
  display: inline-block;
  font-weight: 900;
  font-size: 14px;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const FadeCol = styled(Col)`
  animation: ${fadeIn} 0.5s forwards 1;
  opacity: 0;
`;

export const FormSymbol = styled.div`
  position: absolute;
  top: 1px;
  left: 1px;
  height: 36px;
  width: 38px;
  background: #ccc;
  color: #fff;
  font-weight: bold;
  text-align: center;
  line-height: 38px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
`;

export const Th = styled.th`
  font-size: 12px;
  color: #5b5c5c;
  padding-left: ${({ first }) => (first ? 35 : 0)}px;
  font-weight: 400;
  padding-top: 10px;
  padding-bottom: 10px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 10px;
`;

export const Tr = styled.tr`
  background: #fff;
  margin-bottom: 5px;
`;

export const Thead = styled.thead`
  background: #f2f6fe;
`;

export const TdLabel = styled.div`
  font-size: 10px;
  color: #9699b4;
`;

export const Title = styled.h5`
  margin: 0px;
  display: inline-block;
  line-height: 38px;
`;

export const Td = styled.td`
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: ${({ first }) => (first ? 20 : 0)}px;
  padding-right: ${({ last }) => (last ? 20 : 0)}px;
  ${({first,last}) => {
    if (first) {
      return `
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
      `;
    }

    if (last) {
      return `
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
      `;
    }
  }}
`;

export const GridWrapper = styled.div`
  padding: 10px 0px 20px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid rgba(0,0,0,0.1)
`;